module.exports = __webpack_public_path__ + "static/guten.me-2b034cc4c966b7647755d7137875fde7.png";